import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util} from "@util/util.js";
import coupon_empty from '@/assets/images/coupon_empty.png'
export default class CouponWapView extends BaseView {
    constructor(model) {
        super(model);
        this._model._view = this;
        this._parentEl = this._model._parent._view._couponBoxEl;
        // 优惠券总容器
        this._el = null;
        this.numOne = 0
        // 控制点击详细说明弹框状态
        this.ishidden = false;
        // 防止多次点击

        // console.log('打印itemId', this._model);
    }

    getItems() {
        let html = ''
        // status: 0 未领取  1 已领取
        let that = this;
        this._model._coupons.map((item, index) => {
            if (item.coupon.status == 0) {
                html += `<div class="coupon_item">`
            } else if (item.coupon.status == 1) {
                html += `<div class="coupon_item already_receive">`
            }

            html += `<div class="coupon_content">
          <div class="content_left">`
            if (item.coupon.salesCouponTemplate.templeteType == 1) {
                //  金额券
                html += `<p class="price"><i>￥</i>${item.coupon.amount.showAmount}</p>`
            } else if (item.coupon.salesCouponTemplate.templeteType == 2) {
                //   免息券
                html += `<p class="price" style="font-size:0.22rem;">${item.coupon.salesCouponTemplate.salesCouponInfo.title}</p>`
            } else if (item.coupon.salesCouponTemplate.templeteType == 3) {
                //   折扣券
                html += `<p class="price">${item.coupon.salesCouponTemplate.salesCouponInfo.title.split('.')[0]}<i style="font-style:normal;font-size:0.15rem;">${item.coupon.salesCouponTemplate.salesCouponInfo.title.split('.')[1] != undefined ? "." +item.coupon.salesCouponTemplate.salesCouponInfo.title.split('.')[1] : ''}折</i></p>`
            }
            if (item.coupon.salesCouponTemplate.salesCouponInfo.condition) {
                html += `<p class="condition">${item.coupon.salesCouponTemplate.salesCouponInfo.condition}</p>`
            }
            html += `</div>
          <div class="content_right">
            <h4>${item.coupon.salesCouponTemplate.salesCouponInfo.name}</h4>
            <img class="coupon_get_wap" src="https://p2.lefile.cn/product/adminweb/2020/11/25/83235582-be80-4162-98da-1886fecdf76a.png" />
            <div class="coupon_time">${item.coupon.salesCouponTemplate.salesCouponInfo.terminal}</div>
            <div class="coupon_time">${item.coupon.salesCouponTemplate.salesCouponInfo.validityTime}</div>
            <div class="explain_box">
              <div class="explain_left" data-index=${index}>
                <p>详细说明</p>
                <i class="iconfont icon-coupon-wap-bottom"></i>
                <i class="iconfont icon-coupon-wap-top"></i>
              </div>
              <div class="explain_right">
                <button class="receive" data-couponid="${item.coupon.salesCouponId}" >立即领取</button>`
                if (item.items && item.items.length > 0 && item.stip && !item.full) {
                    html += `<button class="collect_bill" style="margin-left:0.1rem;" data-couponid="${item.coupon.salesCouponId}">去凑单</button>`
                } else if (item.items && item.items.length > 0 && item.stip && item.full) {
                    html += `<button class="collect_bill" style="margin-left:0.1rem;" data-couponid="${item.coupon.salesCouponId}">再逛逛</button>`
                }
                html += `</div>
            </div>
          </div>
        </div>
        <div class="explain_box_info explain_box_${index}" style="display:${that.ishidden ? 'block' : 'none'}">
     
            <ul>
                <li>${item.coupon.salesCouponTemplate.salesCouponInfo.description}</li>
            </ul>
        </div>`
        if (item.items && item.items.length > 0 ) {

                html += `<div class="collect_bill_box">
                    <h6>${item.stip ? item.stip : ''}</h6>
                    <ul class="clearfix" data-status="${item.coupon.status}">`
                    item.items.map((itemq, index) => {
                        html += `
                            <li data-itemId="${itemq.itemId}" data-checked="${itemq.checked}">
                                <p class="pic_box">
                                <img src="${itemq.imgUrl}" />
                                <input type="checkbox" class="iconfont ${itemq.checked ? 'icon-checked' : 'icon-uncheck'}"/>
                                </p>
                                <p class="price">¥${itemq.price.showAmount}</p>
                                <p class="num">x${itemq.num}</p>
                            </li>`
                    })

                html += `</ul>`
                html += `</div>`
            }
            html += `</div>`
        })

        return html
    }

    renderEmpty() {
      return `
        <div style="display: flex; justify-content: center;padding-top: 50px;">
          <img src="${coupon_empty}" style="width: 180px;" />
        </div>
      `
    }

    render() {

        let html = "";
        html += `${this.getItems()}`;
        if(!this._model._coupons.length) {
          html += this.renderEmpty()
        }

        $(this._parentEl.find("div.coupon_list")).html($(html));
        this._el = $('.coupon_wrapper');
        this.regEvent();
    }
    regEvent() {
        let that = this;
        // 点击详细说明点击事件
        this._el.off("click", ".explain_left").on("click", ".explain_left", function () {
            let index = $(this).attr('data-index');
            // 展开详细说明下拉框
            this.ishidden = !this.ishidden;
            if (this.ishidden) {
                $(this).closest(".explain_box").addClass("active")
                $('div.explain_box_' + index).show()
            } else {
                $(this).closest(".explain_box").removeClass("active")
                $('div.explain_box_' + index).hide()
            }
        })

        // 点击去凑单跳转到凑单页面
        this._el.off("click", "button.collect_bill").on("click", "button.collect_bill", function (e) {
            let couponId = $(this).attr('data-couponid');
            // 以后会是线上地址39263993b0723ef8
            window.location.href="./active.html?couponId=" + couponId+'&tag=1';
        })
        // 点击立即领取按钮
        this._el.off("click", "button.receive").on("click", "button.receive", function (e) {
            // console.log(e);
            const currentCouponId = $(e.target).data("couponid")
            that._model.couponBindForOnce({salesCouponId:currentCouponId, goodsCode: that?._model?._parent._id}).then(x=>{
                // console.log(x);
                Alert.showTip("领券成功");
                // that._model.getCouponList().then(
                //     x=>{                      
                //         that._model.init(x.t); 
                //         that.render();                                 
                //     }
                // );

                // FIXME: https://jira.xpaas.lenovo.com/browse/SHOP-70878
                // 领券成功后立即拉取优惠卷列表会返回空，这里前端直接变更状态
                that._model._coupons.some((item) => {
                  if(item.coupon.salesCouponId === currentCouponId) {
                    item.coupon.status = 1
                    return true
                  }
                })
                that.render();
            }).catch(err =>{
                Alert.showTip(err);
            })
        })
        // 点击叉号隐藏优惠券弹窗
        this._el.off("click", ".icon-close").on("click", ".icon-close", function () {
            $('.coupon_wrapper').hide();
            $util.toggleBodyScroller(false);
        })
        // 点击选件凑单发送请求重新请求优惠券
        this._el.off("click", ".collect_bill_box ul li").on("click", ".collect_bill_box ul li", function () {
            $(this).addClass('disabled');
            let status = $(this).parent().attr('data-status');
            if(status == 1){
                that.numOne = 1
            }
            // 判断是已领取还是未领取
           
            let itemId = $(this).attr('data-itemId');
            let cartItemId = that._model._parent._itemId;
            if($(this).children().children('input').attr('class').indexOf('icon-checked')>-1) {
                var checked = false;
            } else if($(this).children().children('input').attr('class').indexOf('icon-uncheck')>-1){
                var checked = true;
            }
            let params = {
                cartItemId: cartItemId,
                itemId: itemId,
                checked: checked
            }
           
            let arr = {};
            arr._invalid = false;
            arr._itemId = itemId;
            arr._isChecked = checked;
            arr._purchaseEnable = true;
           
            that._model.setActive(arr).then().catch(err => { 
                Alert.showTip(err);
            });
            that._model.setCouponCheckedCartItem(params).then(x => {
                // 将数据初始化赋值给this._model
                that._model.init(x.t);
                that.render();
                if(that.numOne == 0 && arr._isChecked) {
                    Alert.showTip("记得领取优惠券");
                    that.numOne = 1
                }
            }).catch(err => {
                Alert.showTip(err);
            });
        })
    }
}